import { useQuery } from "@tanstack/react-query";
import axiosManagerRegister from "../services/axiosManagerRegister";
import { formatTo } from "../utils/dateTimeHelper";

export const useGetStartDates = (disabled) => {
    const {
        isFetching: isLoading, data: startDates, error,
    } = useQuery({
        queryKey: ["startDates"],
        queryFn: () => axiosManagerRegister.get$("/api/api/startDates").then((response) => response?.data),
        initialData: [],
        retry: 0,
        enabled: !disabled,
    });

    const startDatesOptions = (startDates || [])
        .toSorted((a, b) => {
            if (a.displayName.includes("soon as possible")) return -1;
            if (b.displayName.includes("soon as possible")) return 1;
            return new Date(a.startDate) - new Date(b.startDate);
        })
        .map((item) => ({
            value: formatTo(item.startDate || new Date(), "yyyy-MM-dd"),
            label: item.displayName,
        }));

    return {
        isLoading, startDates, error, startDatesOptions,
    };
};
